const isInitialized = ref(false)
export default defineNuxtRouteMiddleware(() => {
  const { gtag } = useGtag()
  if (import.meta.client && !isInitialized.value) {
    nextTick(() => {
      gtag('config', 'G-744EN7FZFC', getGtagConfig())
      isInitialized.value = true
    })
  }
})
